import PropTypes from "prop-types";
import { DashboardGridSkeleton } from "../../dashboard-skeletons/dashboard-skeletons";
import EnergyAnalystsTimeLog from "./energy-analysts-time-log/energy-analysts-time-log";
import DashboardEnergyStafferDealResourceLog from "./dashboard-energy-staffer-deal-resource-log/dashboard-energy-staffer-deal-resource-log";
import { useFluentToast } from "../../../../components/FluentUI/Fluent-Toast";
import EnergyJuniorStaffingIndex from "./energy-junior-staffing-index/energy-junior-staffing-index";
import EnergyProjectHoursByVertical from "./energy-project-hours-by-vertical/energy-project-hours-by-vertical";

const DashboardEnergyStaffer = ({
  energyStafferTimeLogItems,
  isEnergyStafferTimeLogLoading,
  setIsEnergyStafferTimeLogLoading,
  fetchEnergyTechStafferTimeLog,
  energyStafferDealResourceLogItems,
  isEnergyStafferDealResourceLogLoading,
  setIsEnergyStafferDealResourceLogLoading,
  fetchStafferDealDetailsandResourcingLog,
  energyJuniorStaffingIndexData,
  isEnergyJuniorStaffingIndexLoading,
  setIsEnergyJuniorStaffingIndexLoading,
  fetchEnergyJuniorStaffingIndex,
  energyProjectHoursByVerticalData,
  isEnergyProjectHoursByVerticalLoading,
  setIsEnergyProjectHoursByVerticalLoading,
  fetchEnergyProjectHoursByVertical,
  isSI = false,
}) => {
  const { showToast, FluentToast } = useFluentToast();
  return (
    <div>
      {isEnergyStafferTimeLogLoading ?
        <DashboardGridSkeleton width="95vw" />
        :
        energyStafferTimeLogItems && <EnergyAnalystsTimeLog
          energyStafferTimeLogItems={energyStafferTimeLogItems?.JuniorBankers}
          energyStafferTimeLogSummaryItems={energyStafferTimeLogItems?.Summary}
          setIsEnergyStafferTimeLogLoading={setIsEnergyStafferTimeLogLoading}
          fetchEnergyTechStafferTimeLog={fetchEnergyTechStafferTimeLog}
          fetchStafferDealDetailsandResourcingLog={fetchStafferDealDetailsandResourcingLog}
          setIsEnergyStafferDealResourceLogLoading={setIsEnergyStafferDealResourceLogLoading}
          showToast={showToast}
          isSI={isSI}
          fetchEnergyJuniorStaffingIndex={fetchEnergyJuniorStaffingIndex}
          setIsEnergyJuniorStaffingIndexLoading={setIsEnergyJuniorStaffingIndexLoading}

        />
      }
      {
        isEnergyStafferDealResourceLogLoading ?
          <DashboardGridSkeleton width="95vw" />
          :
          energyStafferDealResourceLogItems && <DashboardEnergyStafferDealResourceLog
            energyStafferDealResourceLogItems={energyStafferDealResourceLogItems}
            fetchStafferDealDetailsandResourcingLog={fetchStafferDealDetailsandResourcingLog}
            setIsEnergyStafferDealResourceLogLoading={setIsEnergyStafferDealResourceLogLoading}
            setIsEnergyStafferTimeLogLoading={setIsEnergyStafferTimeLogLoading}
            fetchEnergyTechStafferTimeLog={fetchEnergyTechStafferTimeLog}
            showToast={showToast}
            isSI={isSI}
            fetchEnergyJuniorStaffingIndex={fetchEnergyJuniorStaffingIndex}
            setIsEnergyJuniorStaffingIndexLoading={setIsEnergyJuniorStaffingIndexLoading}
          />
      }
      {
        !isSI && <EnergyJuniorStaffingIndex
          energyJuniorStaffingIndexData={energyJuniorStaffingIndexData}
          fetchEnergyJuniorStaffingIndex={fetchEnergyJuniorStaffingIndex}
          isEnergyJuniorStaffingIndexLoading={isEnergyJuniorStaffingIndexLoading}
          setIsEnergyJuniorStaffingIndexLoading={setIsEnergyJuniorStaffingIndexLoading}
        />
      }
      {
        !isSI && <EnergyProjectHoursByVertical
          energyProjectHoursByVerticalData={energyProjectHoursByVerticalData}
          fetchEnergyProjectHoursByVertical={fetchEnergyProjectHoursByVertical}
          isEnergyProjectHoursByVerticalLoading={isEnergyProjectHoursByVerticalLoading}
          setIsEnergyProjectHoursByVerticalLoading={setIsEnergyProjectHoursByVerticalLoading}
        />
      }
      {FluentToast}
    </div>

  );
};

DashboardEnergyStaffer.propTypes = {
  energyStafferTimeLogItems: PropTypes.shape({
    JuniorBankers: PropTypes.array,
    Summary: PropTypes.object,
  }).isRequired,
  isEnergyStafferTimeLogLoading: PropTypes.bool.isRequired,
  setIsEnergyStafferTimeLogLoading: PropTypes.func.isRequired,
  fetchEnergyTechStafferTimeLog: PropTypes.func.isRequired,
  energyStafferDealResourceLogItems: PropTypes.shape({
    Deals: PropTypes.array,
    EmptySectors: PropTypes.array,
    SectorNames: PropTypes.array,
  }).isRequired,
  isEnergyStafferDealResourceLogLoading: PropTypes.bool.isRequired,
  setIsEnergyStafferDealResourceLogLoading: PropTypes.func.isRequired,
  fetchStafferDealDetailsandResourcingLog: PropTypes.func.isRequired,
  energyJuniorStaffingIndexData: PropTypes.shape({
    ChartData: PropTypes.shape({
      Dates: PropTypes.array,
      EstimatedIndex: PropTypes.array,
      ReportedIndex: PropTypes.array,
    }),
    ExportData: PropTypes.array,
  }),
  isEnergyJuniorStaffingIndexLoading: PropTypes.bool,
  setIsEnergyJuniorStaffingIndexLoading: PropTypes.func,
  fetchEnergyJuniorStaffingIndex: PropTypes.func,
  energyProjectHoursByVerticalData: PropTypes.shape({
    ChartData: PropTypes.arrayOf(
      PropTypes.shape({
        Date: PropTypes.string,
        Sectors: PropTypes.arrayOf(
          PropTypes.shape({
            SectorName: PropTypes.string,
            Hours: PropTypes.number,
          })
        ),
      })
    ),
  }),
  isEnergyProjectHoursByVerticalLoading: PropTypes.bool,
  setIsEnergyProjectHoursByVerticalLoading: PropTypes.func,
  fetchEnergyProjectHoursByVertical: PropTypes.func,
  isSI: PropTypes.bool,
};

export default DashboardEnergyStaffer;
